import React from "react";
import ReactDOM from "react-dom/client";
import {
  BrowserRouter as Router,
} from "react-router-dom";
import App from "./App";
import "./i18n";
import { UserProvider } from "./UseCases/User/UserObject";

import "./index.css";
import "./styling/index.css";
import "./Components/Button/Button.css";
import { registerDebugFlags } from "./util/registerDebugFlags";

registerDebugFlags();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserProvider>
      <Router>
        <App />
      </Router>
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
